<template>
    <div
        class="device device__thermostat"
        style="position: relative;"
        :class="{ modeHeat: modeHeat, 'device--outService': outService }"
        @click.stop="$emit('click')"
    >
        <div class="device__name" :data-icoTarget="spaceType">
            {{ name }}
            <i v-if="subName">{{ subName }}</i>
        </div>
        <ui-TempControlDevice
            :min="min"
            :max="max"
            :real="real"
            :order.sync="order"
            :status="status"
            :standby="standby"
        ></ui-TempControlDevice>
        <div class="d-flex align-items-center">
            <div class="d-flex align-items-center p-2">
                <slot name="properties"></slot>
            </div>
            <div class="p-2 ms-auto">
                <ui-Switch
                    :status="status"
                    :standby="standby"
                    :disabled="disabled"
                    @update:status="$emit('update:status', $event)"
                ></ui-Switch>
            </div>
        </div>
    </div>
</template>

<script>
    import ui_Ico from './ui-Ico.vue';
    import ui_Switch from './ui-Switch.vue';
    import ui_TempControlDevice from './ui-TempControlDevice.vue';

    export default {
        components: {
            ui_TempControlDevice,
            ui_Switch,
            ui_Ico,
        },
        name: 'ui-DeviceThermostat',
        data: function() {
            return {};
        },
        props: {
            name: {
                type: String,
                default: 'Device: Thermostat',
            },
            subName: String,
            spaceType: {
                type: String,
                default: 'installation-thermostat',
            },
            min: {
                type: Number,
                default: 18,
            },
            max: {
                type: Number,
                default: 28,
            },
            real: Number,
            order: Number,
            status: {
                // false: apagado; true: encendido
                type: Boolean,
                default: false,
            },
            standby: {
                // true: en modo de espera, SOLO cuando esta encendido
                type: Boolean,
                default: false,
            },
            disabled: {
                // true: botón desactivado
                type: Boolean,
                default: false,
            },
            modeHeat: {
                type: Boolean,
                default: false,
            },
            outService: {
                // true: device fuera de servicio
                type: Boolean,
                default: false,
            },
        },
        methods: {},
        computed: {},
    };
</script>
